import React from 'react';
import HelmetBuilder from '../components/helmet-builder';
import BlogPostHero from '../components/blog-post-hero';
import BlogPostPullQuote from '../components/blog-post-pull-quote';
import BlogPostImageGallery from '../components/blog-post-image-gallery';
import BlogPostPreview from '../components/blog-post-preview';
import marked from 'marked';

import './blog-post.scss';

const responsifyImages = html => {
  const re = /<img src="([^"]*)/g;
  const matches = html.match(re);
  return html.replace(re, '$&?w=600&fm=jpg&fl=progressive&q=80');
};

const Template = ({ data, location }) => {
  const { post, nextPost } = data;

  return (
    <div className="blog-post">
      <HelmetBuilder
        data={data.post}
        pathname={location.pathname}
      />
      <BlogPostHero
        title={post.title}
        slug={post.slug}
        imageUrl={post.heroImage && post.heroImage.file ? post.heroImage.file.url : ''}
        author={post.postAuthor ? post.postAuthor.name : ''}
        category={post.category ? post.category.title : ''}
        date={post.postDate}
        link={false}
      />
      <div className="blog-post__copy blog-post__intro-quote">
        <h2>
          {post.introductoryQuote ? post.introductoryQuote.introductoryQuote : ''}
        </h2>
      </div>
      {post.video &&
        <div className="blog-post__video-wrapper">
          <video controls controlsList="nodownload">
            <source src={post.video ? post.video.file ? post.video.file.url : '' : ''} type="video/mp4" />
          </video>
        </div>}
      <div
        className="blog-post__copy"
        dangerouslySetInnerHTML={{
          __html: responsifyImages(marked(post.copyBlock1 ? post.copyBlock1.copyBlock1 : ''))
        }}
      />
      {post.pullQuote &&
        <BlogPostPullQuote
          imageUrl={(post.pullQuoteImage && post.pullQuoteImage.file ? post.pullQuoteImage.file.url : '')}
          quote={post.pullQuote ? post.pullQuote.pullQuote : ''}
        />}
      {post.copyBlock2 &&
        <div
          className="blog-post__copy"
          dangerouslySetInnerHTML={{
            __html: marked(post.copyBlock2 ? post.copyBlock2.copyBlock2 : '')
          }}
        />}
      {post.imageGallery && <BlogPostImageGallery images={post.imageGallery} />}
      {post.imageGalleryQuote &&
        <BlogPostPullQuote quote={post.imageGalleryQuote.imageGalleryQuote} />}
      {post.copyBlock3 &&
        <div
          className="blog-post__copy"
          dangerouslySetInnerHTML={{
            __html: marked(post.copyBlock3 ? post.copyBlock3.copyBlock3 : '')
          }}
        />}
      {!nextPost
        ? null
        : <BlogPostPreview
            heading="Read Next"
            imageUrl={nextPost.heroImage && nextPost.heroImage.file ? nextPost.heroImage.file.url : ''}
            title={nextPost.title}
            author={nextPost.nextPostAuthor ? nextPost.postAuthor.name : ''}
            date={nextPost.postDate}
            excerpt={nextPost.introductoryQuote ? nextPost.introductoryQuote.introductoryQuote : ''}
            category={nextPost.category ? nextPost.category.title : ''}
            slug={nextPost.slug}
          />}
    </div>
  );
};

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!, $hasNext: Boolean!, $nextSlug: String!) {
    post: contentfulBlogPost(slug: { eq: $slug }) {
      id
      title
      slug
      metadata {
        title
        description
        ogimage {
          file {
            url
          }
        }
        keywords
      }
      postDate
      postAuthor {
        name
      }
      category {
        title
      }
      featured
      heroImage {
        id
        title
        description
        responsiveResolution(quality: 75, toFormat: JPG) {
          width
          height
          src
          srcSet
        }
        file {
          url
          fileName
          contentType
        }
      }
      introductoryQuote {
        id
        introductoryQuote
      }
      copyBlock1 {
        id
        copyBlock1
      }
      pullQuote {
        id
        pullQuote
      }
      pullQuoteImage {
        id
        title
        description
        file {
          url
          fileName
          contentType
        }
      }
      copyBlock2 {
        id
        copyBlock2
      }
      imageGallery {
        id
        title
        description
        file {
          url
          fileName
          contentType
        }
      }
      imageGalleryQuote {
        id
        imageGalleryQuote
      }
      copyBlock3 {
        id
        copyBlock3
      }
      video {
        file {
          url
        }
      }
    }
    nextPost: contentfulBlogPost(slug: { eq: $nextSlug })
      @include(if: $hasNext) {
      id
      title
      slug
      postDate
      postAuthor {
        name
      }
      category {
        title
      }
      heroImage {
        file {
          url
        }
      }
      introductoryQuote {
        introductoryQuote
      }
    }
  }
`;

export default Template;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js